import { useState } from "react";
import SingleUserForm from "./SingleUserForm";
import { IconButton, Tooltip } from "@mui/material";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { useGetProfileCategoryQuery } from "../../../api/admin/gestioneNewsApi";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import { useGetStudiosQuery } from "../../../api/admin/gestisciStudioApi";
import { t } from "i18next";

function MultipleUser({
  formFields,
  setFormFields,
  validationFormFieldsErrors,
  setValidationFormFieldsErrors,
}) {
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] = useState();

  const { data: studios } = useGetStudiosQuery({
    ...{ currentPage: 1, startRow: 0, endRow: TABLE_ROWS_NUMBER },
    value: debouncedInputStudioValue,
  });
  const { data: dataListCategory } = useGetProfileCategoryQuery();

  const handleFormChange = (event, index, forcedName, forcedValue) => {
    let data = [...formFields];
    data[index][forcedName !== undefined ? forcedName : event?.target?.name] =
      forcedValue || event?.target?.value;
    setFormFields(data);

    if (validationFormFieldsErrors.length > 0) {
      let errorData = [...validationFormFieldsErrors];
      let errorObj = { ...errorData[index] };
      delete errorObj[
        forcedName !== undefined ? forcedName : event?.target?.name
      ];
      errorData[index] = errorObj;
      setValidationFormFieldsErrors(errorData);
    }
  };

  const handleFormSameRefStudioChange = (event, index) => {
    let data = [...formFields];
    data[index]["sameRefStudio"] = event?.target?.checked;
    data[index]["studio"] = "";
    data[index]["commercialista"] = "";
    setFormFields(data);
    if (validationFormFieldsErrors.length > 0) {
      let errorData = [...validationFormFieldsErrors];
      let errorObj = { ...errorData[index] };
      delete errorObj["studio"];
      delete errorObj["commercialista"];
      errorData[index] = errorObj;
      setValidationFormFieldsErrors(errorData);
    }
  };

  const addFields = () => {
    let object = {
      nome: "",
      cognome: "",
      email: "",
      codiceFiscale: "",
      studio: "",
      commercialista: "",
      occupazione: "",
      sameRefStudio: true,
    };
    setFormFields([...formFields, object]);
  };

  const removeFields = (index) => {
    let data = [...formFields];
    data.splice(index, 1);
    setFormFields(data);
  };

  return (
    <div className="flex flex-col ">
      {formFields.map((form, index) => {
        return (
          <div
            className="flex items-center mt-10 pl-10 pr-10 pb-10 shadow-md rounded-xl"
            key={index}
          >
            <SingleUserForm
              form={form}
              index={index}
              handleFormChange={handleFormChange}
              handleFormSameRefStudioChange={handleFormSameRefStudioChange}
              dataListCategory={dataListCategory}
              studios={studios}
              setDebouncedInputStudioValue={setDebouncedInputStudioValue}
              validationErrors={validationFormFieldsErrors[index]}
            />

            <div className="flex w-fit h-fit justify-start">
              <Tooltip title={`${t("Delete")} ${t("user")}`}>
                <IconButton
                  className="mt-2 text-rose-700 bg-rose-50 hover:bg-rose-200 hover:text-rose-800"
                  onClick={() => removeFields(index)}
                >
                  <HighlightOffRoundedIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
      })}
      <div className="flex w-full justify-center mt-8">
        <Tooltip title={t("AddAdditionalUsers")}>
          <IconButton onClick={addFields} className="text-primary">
            <AddCircleOutlineRounded />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
}

export default MultipleUser;
